import Hash from 'ipfs-only-hash'

import { config } from '@/config'

export function getIpfsUrl(cid: string | undefined): string | null {
  if (!cid) return null
  return `${config.VITE_IPFS_GATEWAY_URL}/ipfs/${cid}`
}

export function stableJsonStringify(value: unknown): string {
  const serialize = (current: unknown): unknown => {
    if (current === null || current === undefined) return current
    if (typeof current !== 'object') return current
    if (Array.isArray(current)) return current.map(serialize)

    const record = current as Record<string, unknown>
    const sortedKeys = Object.keys(record).sort((a, b) => a.localeCompare(b))
    const result: Record<string, unknown> = {}

    for (const key of sortedKeys) {
      result[key] = serialize(record[key])
    }

    return result
  }

  return JSON.stringify(serialize(value))
}

export async function calculateCidFromBytes(
  bytes: Uint8Array,
): Promise<string> {
  return Hash.of(bytes)
}

export async function calculateCidFromFile(file: File): Promise<string> {
  const buffer = await file.arrayBuffer()
  return calculateCidFromBytes(new Uint8Array(buffer))
}
